import { HELP_CATEGORIES, HELP_TOPICS, HELP_FAQS } from './help.data';
import { HelpCategoryMeta, HelpCategoryType, HelpTopic } from './help.types';

export class HelpController {
  public static getCategories(): HelpCategoryMeta[] {
    return HELP_CATEGORIES;
  }

  public static getAllTopics(): HelpTopic[] {
    return HELP_TOPICS;
  }

  public static getFAQs() {
    return HELP_FAQS;
  }

  public static getStats() {
    const totalTopics = HELP_TOPICS.length;
    const totalRules = HELP_TOPICS.reduce((acc, t) => acc + t.rulesAndValidations.length, 0);
    const totalSteps = HELP_TOPICS.reduce((acc, t) => acc + t.howToDoSteps.length, 0);
    const totalFAQs = HELP_FAQS.length;

    return {
      totalTopics,
      totalRules,
      totalSteps,
      totalFAQs
    };
  }

  public static filterTopics(categoryId: HelpCategoryType, searchQuery: string): HelpTopic[] {
    let list = HELP_TOPICS;

    if (categoryId !== 'ALL') {
      list = list.filter(t => t.categoryId === categoryId);
    }

    const query = (searchQuery || '').trim().toLowerCase();
    if (!query) {
      return list;
    }

    return list.filter(t => {
      const matchTitle = t.title.toLowerCase().includes(query);
      const matchSub = t.subtitle.toLowerCase().includes(query);
      const matchOverview = t.overview.toLowerCase().includes(query);
      const matchCategory = t.categoryName.toLowerCase().includes(query);
      const matchKeywords = t.keywords.some(k => k.toLowerCase().includes(query));
      const matchWhatItDoes = t.whatItDoes.some(w => w.toLowerCase().includes(query));
      const matchSteps = t.howToDoSteps.some(s => s.title.toLowerCase().includes(query) || s.description.toLowerCase().includes(query));
      const matchRules = t.rulesAndValidations.some(r => r.title.toLowerCase().includes(query) || r.description.toLowerCase().includes(query));
      const matchTips = t.tipsAndBestPractices.some(tp => tp.toLowerCase().includes(query));

      return matchTitle || matchSub || matchOverview || matchCategory || matchKeywords || matchWhatItDoes || matchSteps || matchRules || matchTips;
    });
  }

  public static filterFAQs(searchQuery: string) {
    const query = (searchQuery || '').trim().toLowerCase();
    if (!query) return HELP_FAQS;

    return HELP_FAQS.filter(faq => 
      faq.question.toLowerCase().includes(query) || faq.answer.toLowerCase().includes(query)
    );
  }
}
